import { TableHead, TableRow, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import React from "react";
import { Employee } from "../../graphql/baseTypes";
import Loader from "../Loading/Loader";
import { StyledTableCell } from "../Table";
import EmployeeTableItem from "./EmployeeTableItem";

interface Props {
  employees: Array<Employee>;
  rowsPerPage: number;
  page: number;
  loading?: boolean;
  selected?: Array<string>;
  onClickItem: (id: string) => any;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  handleChangeRowsPerPage?: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  >;
  totalEmployees?: number;
}
const useStyles = makeStyles({
  root: {
    marginTop: 20,
    width: "100%",
  },
  container: {
    maxHeight: 510,
  },
  empty: {
    margin: "40px 0",
  },
});
type EmployeeKeys = keyof Employee;

export const columns: Array<{
  id: EmployeeKeys;
  label: string;
  minWidth?: number;
  align?: "inherit" | "left" | "center" | "right" | "justify";
}> = [
  {
    id: "identifier",
    label: "Typ",
    minWidth: 80,
    align: "left",
  },
  {
    id: "insuranceNumber",
    label: "Identifier Nr.",
    minWidth: 80,
    align: "left",
  },
  {
    id: "location",
    label: "Standort",
    minWidth: 80,
    align: "left",
  },
  { id: "patient", label: "Patient", minWidth: 160 },
  { id: "address", label: "Adresse", minWidth: 20 },
  { id: "birthdate", label: "Geburtsdatum", minWidth: 80 },
  { id: "expiresAt", label: "Läuft ab am", minWidth: 80 },
];
const TestTable: React.FC<Props> = ({
  employees,
  handleChangeRowsPerPage,
  handleChangePage,
  page,
  rowsPerPage,
  loading,
  totalEmployees = 0,
  onClickItem,
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading &&
              employees.map((row, index) => {
                const KEY = `${row.locationId}#${row.insuranceNumber}`;
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <EmployeeTableItem
                    key={KEY}
                    item={row}
                    columns={columns}
                    labelId={labelId}
                    onClickItem={onClickItem}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {loading && <Loader />}

      {employees.length === 0 && !loading && (
        <Typography
          align="center"
          variant="subtitle1"
          className={classes.empty}
        >
          Keine Testpersonendaten gefunden
        </Typography>
      )}
      <TablePagination
        rowsPerPageOptions={[25, 100, 200]}
        component="div"
        count={totalEmployees}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default TestTable;
